var map = {
	"./Gif_ChemistER.gif": 54,
	"./Gif_DelftER.gif": 55,
	"./Gif_GratisER.gif": 56,
	"./Gif_KaapseER.gif": 57,
	"./Gif_MoordER.gif": 58,
	"./Gif_PrisonbreakER.gif": 59,
	"./Gif_SterrenER.gif": 60,
	"./Titel_image_CSI_DH.jpg": 61,
	"./Titel_image_Delft.jpg": 62,
	"./Titel_image_Kaapse.jpg": 63,
	"./Titel_image_Philosophers_stone.jpg": 64,
	"./Titel_image_Ruimte.jpg": 65,
	"./Titel_image_Werfkelder.jpg": 66,
	"./Titel_image_prison_break.jpg": 67
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22;